var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAaa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340",
    transform: "translate(2880.5 17556.021)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187",
    transform: "translate(-2878 -17553.609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M75,0A75,75,0,1,1,0,75,75,75,0,0,1,75,0Z",
    transform: "translate(0 0.088)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M59,0A59,59,0,1,1,0,59,59,59,0,0,1,59,0Z",
    transform: "translate(6 16.088)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 75,
    cy: 75,
    r: 75,
    transform: "translate(0 0.088)",
    fill: "none",
    stroke: "#c10e16",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M366.408,188.082a62.953,62.953,0,0,0-16.089-2.175c-3.807.057-5.395-1.734-6.146-5.546-.155-.8-.3-1.6-.485-2.389-1.578-6.657-7.325-12.188-12.736-12.789,2.114,3.176,4.708,6.523,6.693,10.2,2.351,4.355.6,8.417-3.936,10.4-1.9.832-3.8,1.662-5.636,2.628a7.508,7.508,0,0,0-4.214,5.6c-.311,1.7-1.449,3.24-2.2,4.862-1.086,2.353-2.877,4.654-3.073,7.081-.328,4.075-2.214,7.145-4.443,10.235-1.32,1.832-2.547,3.733-3.828,5.593-2.556,3.716-1.719,7.489,2.181,10.034a4.134,4.134,0,0,0,4.983.033,88.471,88.471,0,0,1,11.352-6.27c11.767-5.041,16.337-6.482,25.3-.676C355.7,215.66,366.408,188.082,366.408,188.082Zm-7.7,7.352c-2.843,7.174-10.919,11.732-18.379,10.347a15.71,15.71,0,0,1-2.339-.655c-1.755-.619-2.449-1.9-1.791-3.623.615-1.607,1.884-2.021,3.534-1.4,3.953,1.48,7.439.576,10.519-2.19a6.493,6.493,0,0,0,.591-.923,107.042,107.042,0,0,1-11.091-3.568c-1.3-.564-1.947-2.642-3.216-4.5,4.077-1.1,7.31-.911,10.17.8a13.48,13.48,0,0,0,9.3,1.877C358.438,191.237,359.617,193.136,358.706,195.434Zm-26.664-15-8.393-8c3.841.954,7.371,1.3,9.05,4.888.419.9.165,2.106.221,3.171Z",
    transform: "translate(-3140.631 -17680.219)",
    fill: "#c10e16"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAaa);
export default __webpack_public_path__ + "static/media/aaa.31a595feca0283f6c68ad26978e2143b.svg";
export { ForwardRef as ReactComponent };